// extracted by mini-css-extract-plugin
export default {"header":"Header_header__0tS12","main-image":"Header_main-image__OvI0G"};